import { fromJS } from 'immutable';
import actionTypes from 'constants/finalWizardConstants';

export const initialState = fromJS({
  currentStep: "email",
});

const finalWizardReducer = (state = initialState, action) => {
  switch(action.type) {
    case actionTypes.FINAL_GO_TO_STEP:
      return state.set('currentStep', action.payload);
    default:
      return state;
  }
};

export default finalWizardReducer;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/reducers/finalWizardReducer.js